/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import { connect } from "react-redux";
import { Chip, Tooltip, TextField, Typography, InputAdornment } from "@material-ui/core";
import { Clear } from "@material-ui/icons";

import toJs from "../../../hoc/toJS";
import select from "../../../utils/select";

import KPTable from "../../../components/KPTable";
import PatentDeleteModal from "../PatentDeleteModal";
import PatentUpdateModal from "../PatentUpdateModal";
import HemisCodeConfirmModal from "../../../components/HemisCodeConfirmModal/HemisCodeConfirmModal";

import { statisticUnaccepted } from "../../../reducer/profile/action";
import { acceptPatent, updatePatent } from "../../../reducer/patent/action";
import { notification } from "../../../reducer/home/action";

function PatentTable(props) {
  const [editting, setEditting] = useState(null);
  const [deleting, setDeleting] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [confirmingAccept, setConfirmingAccept] = useState(null);

  const updating = props.updating;
  const setUpdating = props.setUpdating;

  const handleUpdate = (e) => setUpdating(e);
  const handleEditYear = (e) => setEditting(e);

  const handleDelete = (event, e) => {
    setDeleting(e.id);
    setAnchorEl(event.currentTarget);
  };

  const handleChange = (value) => setEditting({ ...editting, dashboardYear: value });

  const handleAccept = (e) => {
    // If already accepted (canceling confirmation), no need for modal
    if (e.accepted) {
      props.acceptPatent(e.id, !e.accepted).then((success) => {
        if (success) {
          props.statisticUnaccepted({ departmentId: 0, profileId: props.profile?.id });
          if (props.role === "sudo-admin") props.statisticUnaccepted({ departmentId: 0, profileId: 0 });
        }
      });
    } else {
      // If not accepted (confirming), show modal for HemisCode
      setConfirmingAccept(e);
    }
  };

  const handleConfirmAccept = (hemisCode) => {
    const updatedData = {
      ...confirmingAccept,
      hemisCode: hemisCode,
    };

    // First update the patent with hemisCode
    props.updatePatent(confirmingAccept.id, updatedData).then((updateResult) => {
      // Check for ERR_HEMIS_DUPLICATE error
      if (updateResult && updateResult.error === "ERR_HEMIS_DUPLICATE") {
        props.pushNoti({
          type: "warning",
          message: `Mã CTKH "${hemisCode}" đã tồn tại trong hệ thống. Vui lòng kiểm tra lại!`,
        });
        return;
      }

      if (updateResult && updateResult.success) {
        // Then call accept API
        props.acceptPatent(confirmingAccept.id, !confirmingAccept.accepted).then((acceptSuccess) => {
          if (acceptSuccess) {
            props.statisticUnaccepted({ departmentId: 0, profileId: props.profile?.id });
            if (props.role === "sudo-admin") props.statisticUnaccepted({ departmentId: 0, profileId: 0 });
          }
        });
      }
    });

    setConfirmingAccept(null);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    props.updatePatent(editting.id, editting);
    setEditting(null);
  };

  const handleClear = () => {
    props.updatePatent(editting.id, { ...editting, dashboardYear: null });
    setEditting(null);
  };

  const list = [];
  if (props.type === "all") props.listPatent.forEach((e) => list.push(e.patent));
  else props.listPatentById.forEach((e) => list.push(e.patent));

  return (
    <>
      <KPTable
        shadow="none"
        rowsPerPage={10}
        maxHeight="calc(100vh - 288px)"
        columns={[
          {
            title: <b>Tên giải pháp</b>,
            key: "title",
            width: props.role === "sudo-admin" ? "14%" : "22%",
            sortable: true,
            searchable: true,
          },
          {
            title: <b>Mã công trình</b>,
            key: "hemisCode",
            width: "9%",
            searchable: true,
            render: (value) =>
              value ? (
                <span style={{ wordBreak: "break-word" }}>{value}</span>
              ) : (
                <span style={{ color: "#aaa" }}>—</span>
              ),
          },
          {
            title: <b>Nhóm tác giả</b>,
            key: "authorTeam",
            width: "20%",
            render: (value, row) => {
              if (!row?.patentProfile || row.patentProfile.length === 0) {
                return value || "-";
              }
              const authors = row.patentProfile
                .map((member) => {
                  if (member.isInternal) {
                    return props.profileList.find((p) => p.id === member.profileId)?.name || "";
                  } else {
                    return member.externalName || "";
                  }
                })
                .filter((name) => name !== "")
                .join(", ");
              return authors || "-";
            },
          },
          {
            title: <b>Mục đích</b>,
            key: "purposeId",
            width: "15%",
            type: "include",
            filters: props.purposes
              .filter((e) => e.name !== "bonusCalculated")
              .map((e) => ({ value: e.id, text: e.description })),
            onFilter: (value, row) => row.filter((e) => value.includes(e.purposeId)),
            render: (value) =>
              props.purposes.filter((e) => e.name !== "bonusCalculated").find((e) => e.id === value)?.description,
          },
          props.role === "sudo-admin" && props.type === "all"
            ? {
                title: <b>Năm hiển thị</b>,
                key: "dashboardYear",
                width: "12%",
                searchable: true,
                render: (value, row) =>
                  row?.id !== editting?.id ? (
                    <Tooltip title="Click để chỉnh sửa năm">
                      <div style={{ cursor: "pointer" }} onClick={() => handleEditYear(row)}>
                        {value > 0 ? value : "Chưa có năm hiển thị"}
                      </div>
                    </Tooltip>
                  ) : (
                    <form onSubmit={handleSubmit}>
                      <TextField
                        fullWidth
                        size="small"
                        type="tel"
                        variant="outlined"
                        value={editting?.dashboardYear || ""}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end" style={{ cursor: "pointer" }} onClick={handleClear}>
                              <Clear style={{ fontSize: 18 }} />
                            </InputAdornment>
                          ),
                        }}
                        onChange={(e) => handleChange(parseInt(e.target.value))}
                      />
                    </form>
                  ),
              }
            : {
                key: "dashboardYear",
                width: "0%",
                render: () => null,
              },
          {
            title: <b>Trạng thái</b>,
            key: "accepted",
            width: "15%",
            render: (value) => (
              <Chip
                size="small"
                color={value ? "primary" : "secondary"}
                label={value ? "Đã được duyệt" : "Chưa được duyệt"}
              />
            ),
            type: "include",
            filters: [
              {
                text: "Đã được duyệt",
                value: true,
              },
              {
                text: "Chưa được duyệt",
                value: false,
              },
            ],
            onFilter: (value, row) => row.filter((e) => value.includes(e.accepted)),
          },
          {
            title: <b>Tác vụ</b>,
            key: "action",
            width: "20%",
            render: (value, row) =>
              row?.id !== editting?.id ? (
                <>
                  <Typography
                    className="table-action-buton"
                    variant="caption"
                    color="primary"
                    onClick={() => handleUpdate(row)}
                  >
                    Chi tiết
                  </Typography>
                  {row.locked ? (
                    <Typography className="table-action-buton" variant="caption" color="textPrimary">
                      {`Đã khóa ${
                        (row.locked === "kpi" && "KPI") ||
                        (row.locked === "reward" && "thưởng") ||
                        (row.locked === "timeResearch" && "giờ nghiên cứu")
                      }`}
                    </Typography>
                  ) : (
                    <>
                      {(props.type !== "all" || props.role === "sudo-admin") && !row.accepted && (
                        <Typography
                          className="table-action-buton"
                          variant="caption"
                          color="secondary"
                          onClick={(event) => handleDelete(event, row)}
                        >
                          Xoá
                        </Typography>
                      )}
                      {props.role === "sudo-admin" && props.filter !== "workingPaper" && row.purposeId !== 4 && (
                        <>
                          <Typography
                            className="table-action-buton"
                            variant="caption"
                            color="primary"
                            onClick={(event) => handleAccept(row)}
                          >
                            {row.accepted ? "Hủy xác nhận" : "Xác nhận"}
                          </Typography>
                        </>
                      )}
                    </>
                  )}
                </>
              ) : (
                <>
                  <Typography className="table-action-buton" variant="caption" color="primary" onClick={handleSubmit}>
                    Lưu
                  </Typography>
                  <Typography
                    className="table-action-buton"
                    variant="caption"
                    color="secondary"
                    onClick={() => setEditting(null)}
                  >
                    Huỷ
                  </Typography>
                </>
              ),
          },
        ]}
        rows={list.sort((a) => (!a.accepted ? -1 : 1))}
        loading={props.isFetching}
      />
      <PatentUpdateModal adminTab={props.adminTab} updating={updating} setUpdating={setUpdating} />
      <PatentDeleteModal deleting={deleting} anchorEl={anchorEl} setAnchorEl={setAnchorEl} />
      <HemisCodeConfirmModal
        open={!!confirmingAccept}
        onClose={() => setConfirmingAccept(null)}
        onConfirm={handleConfirmAccept}
        currentHemisCode={confirmingAccept?.hemisCode || ""}
        title={confirmingAccept?.accepted ? "Hủy xác nhận bằng sáng chế" : "Xác nhận bằng sáng chế"}
      />
    </>
  );
}

const mapStateToProps = (state) => ({
  role: select(state, "userReducer", "role"),
  profile: select(state, "profileReducer", "detail"),
  profileList: select(state, "profileReducer", "list"),
  isFetching: select(state, "patentReducer", "isFetching"),
  listPatent: select(state, "patentReducer", "listFiltered"),
  listPatentById: select(state, "patentReducer", "listById"),
  purposes: select(state, "scientificResearchReducer", "purposes"),
});

const mapDispatchToProps = (dispatch) => ({
  acceptPatent: (id, accept) => dispatch(acceptPatent(id, accept)),
  updatePatent: (id, payload) => dispatch(updatePatent(id, payload)),
  statisticUnaccepted: (payload) => dispatch(statisticUnaccepted(payload)),
  pushNoti: (payload) => dispatch(notification(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(toJs(PatentTable));

